<script>
  import { faDoNotEnter } from "@fortawesome/pro-solid-svg-icons"
  import { Callout, Text, Icon } from "@gl/design-system"
  import { _ } from "../stores/index"
  export let type
</script>

<Callout status="warning">
  <Icon icon={faDoNotEnter} />
  <Text>{$_(`missing.policies.warning.${type}`)}</Text>
</Callout>
